import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Button, Container, Row, Col, Card, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import { baseUrl } from "../../ApiCheck/Constant";
import Context from '../../Context/Context';
import { useNavigate } from 'react-router-dom';
import Loader from '../../ApiCheck/Loader';

function Cart() {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [addresses, setAddresses] = useState([]);
  console.log("addresses", addresses)
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [newAddress, setNewAddress] = useState({
    city: '',
    state: '',
    country: '',
    pinCode: '',
    addressLine1: '',
    addressLine2: ''
  });
  const [showAddressForm, setShowAddressForm] = useState(false);


  const user = useSelector((state) => state.user);
  console.log("user", user)
  console.log("cartItems", cartItems)
  const navigate = useNavigate();
  const { fetchCartCount } = useContext(Context);

  const calculateTotal = (items) => {
    const total = items.reduce((acc, item) => acc + item.price * item.quantity, 0);
    setTotalAmount(total);
  };

  const fetchCart = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseUrl}/api/cart`);
      const data = response.data.data;
      setCartItems(data);
      calculateTotal(data);
    } catch (error) {
      toast.error('Failed to fetch cart items. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchAddresses = async () => {
      const res = await axios.get(`http://localhost:4000/api/getaddress/${user?.user?._id}`);
      setAddresses(res.data.data);
    };
  
    fetchAddresses();
  }, []);
  

  useEffect(() => {
    if (!user.isAuth) {
      navigate('/');
    } else {
      fetchCart();
    }
  }, [user]);

  const handleQuantityChange = async (productId, newQuantity, product) => {
    if (newQuantity < 1) return;
    setLoading(true);
    try {
      const payload = { ...product, quantity: newQuantity };
      await axios.put(`${baseUrl}/api/updatecart/${productId}`, payload);
      const updatedCart = cartItems.map((item) =>
        item._id === productId ? { ...item, quantity: newQuantity } : item
      );
      setCartItems(updatedCart);
      calculateTotal(updatedCart);
      fetchCartCount();
      toast.success(`Updated quantity for ${product.name}`);
    } catch (error) {
      toast.error('Failed to update quantity. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveFromCart = async (productId) => {
    setLoading(true);
    try {
      await axios.delete(`${baseUrl}/api/deletecart/${productId}`);
      const updatedCart = cartItems.filter((item) => item._id !== productId);
      setCartItems(updatedCart);
      calculateTotal(updatedCart);
      fetchCartCount();
      toast.success('Product removed from cart');
    } catch (error) {
      toast.error('Failed to remove product. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handlePayment = async () => {
    const { data } = await axios.post("http://localhost:4000/api/order", {
      totalAmount,
    });


    const options = {
      key: "rzp_test_7t99MHMddDzf4a", // Enter the Key ID generated from the Dashboard
      amount: data.order.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: "INR",
      name: "Shubham Gadhiya",
      description: "Test Transaction",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTiAtXFhPZbi68HHHERicZ6dNolR8EEsylfj-lgm_BqtH1PJgn5Z1nEovw&s",
      order_id: data.order.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
      callback_url: "",
      prefill: {
        name: "Shubham Gadhiya",
        email: "shubhamgadhiya2002@gmail.com",
        contact: "9428793010",
      },
      notes: {
        address: "Razorpay Corporate Office",
        userID: user && user.user._id,
        cartItem: cartItems,
        total:totalAmount
      },
      theme: {
        color: "#0000ff",
      },
      handler: async function (response) {
        try {
          // Step 3: Send payment + cart/user data to backend for verification
          const { data } = await axios.post("http://localhost:4000/api/paymentVerification", {
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature,
            userID: user?.user._id,
           addresseID: selectedAddressId,
            cartItems: cartItems,
            totalAmount: totalAmount,
          });
      
          // If backend sends a redirect instruction
          if (data.redirectTo) {
            navigate(data.redirectTo); // e.g., /user or /order-success
          }
        } catch (error) {
          console.error("Payment verification failed:", error);
        }
      }
     
    };

    const razor = new window.Razorpay(options);
    razor.open();
  };


  return (
    <Container className="mt-4">
      <ToastContainer />
      {loading ? (
        <Loader />
      ) : cartItems.length > 0 ? (
        <Row>
          <Col md={8}>
            <Row className="gy-3">
              {cartItems.map((product) => (
                <Col md={6} key={product._id}>
                  <Card className="h-100 shadow-sm border-0">
                    <Card.Img
                      variant="top"
                      src={product.image}
                      className="w-50 mx-auto my-3"
                      alt={product.name}
                    />
                    <Card.Body className="d-flex flex-column">
                      <Card.Title className="text-truncate">{product.name}</Card.Title>
                      <Card.Text className="text-muted text-truncate">{product.description}</Card.Text>
                      <p className="fw-bold text-primary">${product.price}</p>
                      <div className="d-flex justify-content-between align-items-center mt-auto">
                        <div>
                          <strong>Qty:</strong>
                          <Button className="mx-2 px-2" variant="outline-secondary" onClick={() => handleQuantityChange(product._id, product.quantity - 1, product)} disabled={product.quantity <= 1}>−</Button>
                          {product.quantity}
                          <Button className="mx-2 px-2" variant="outline-secondary" onClick={() => handleQuantityChange(product._id, product.quantity + 1, product)}>+</Button>
                        </div>
                        <Button variant="danger" onClick={() => handleRemoveFromCart(product._id)}>Remove</Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>

          {/* <Col md={4}>
            <Card className="shadow-sm p-3">
              <h5>Order Summary</h5>
              <hr />
              <p><strong>Total Items:</strong> {cartItems.reduce((acc, item) => acc + item.quantity, 0)}</p>
              <p><strong>Total Price:</strong> ${totalAmount.toFixed(2)}</p>
              <Button className="w-100 mt-3" variant="success" onClick={handlePayment}>
                Proceed to Pay
              </Button>
            </Card>
          </Col> */}
       <Col md={4}>
  <Card className="shadow-sm p-3">
    <h5>Select Delivery Address</h5>

    { addresses.length > 0 ? (
      addresses.map((addr) => (
        <Form.Check
          type="radio"
          id={addr._id}
          key={addr._id}
          name="selectedAddress"
          label={
            <>
              {addr.addressLine1}, {addr.addressLine2}<br />
              {addr.city}, {addr.state} - {addr.pinCode}<br />
              {addr.country}
            </>
          }
          onChange={() => setSelectedAddressId(addr._id)}
          checked={selectedAddressId === addr._id}
          className="mb-2"
        />
      ))
    ) : (
      <p>No saved addresses</p>
    )}

    <hr />

    {!showAddressForm ? (
      <Button variant="outline-primary" onClick={() => setShowAddressForm(true)}>
        + Add New Address
      </Button>
    ) : (
      <>
        <h6 className="mt-3">Add New Address</h6>

        {/* Address Form */}
        <Form.Group className="mb-2">
          <Form.Label>City</Form.Label>
          <Form.Control
            type="text"
            value={newAddress.city}
            onChange={(e) => setNewAddress({ ...newAddress, city: e.target.value })}
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label>State</Form.Label>
          <Form.Control
            type="text"
            value={newAddress.state}
            onChange={(e) => setNewAddress({ ...newAddress, state: e.target.value })}
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label>Country</Form.Label>
          <Form.Control
            type="text"
            value={newAddress.country}
            onChange={(e) => setNewAddress({ ...newAddress, country: e.target.value })}
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label>Pin Code</Form.Label>
          <Form.Control
            type="text"
            value={newAddress.pinCode}
            onChange={(e) => setNewAddress({ ...newAddress, pinCode: e.target.value })}
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label>Address Line 1</Form.Label>
          <Form.Control
            type="text"
            value={newAddress.addressLine1}
            onChange={(e) => setNewAddress({ ...newAddress, addressLine1: e.target.value })}
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label>Address Line 2</Form.Label>
          <Form.Control
            type="text"
            value={newAddress.addressLine2}
            onChange={(e) => setNewAddress({ ...newAddress, addressLine2: e.target.value })}
          />
        </Form.Group>

        <Button
          className="mt-2"
          onClick={async () => {
            const { city, state, country, pinCode, addressLine1, addressLine2 } = newAddress;

            if (!city || !state || !country || !pinCode || !addressLine1 || !addressLine2) {
              alert("Please fill in all the address fields.");
              return;
            }

            try {
              const res = await axios.post("http://localhost:4000/api/address", {
                ...newAddress,
                userId: user?.user._id,
              });

              // Safely append the new address
              setAddresses((prev) => [...prev, res.data.data]);

              // Reset
              setNewAddress({
                city: '',
                state: '',
                country: '',
                pinCode: '',
                addressLine1: '',
                addressLine2: ''
              });

              setShowAddressForm(false); // hide form again
            } catch (err) {
              console.error("Failed to save address:", err);
              alert("Something went wrong. Please try again.");
            }
          }}
        >
          Save Address
        </Button>
      </>
    )}

    {selectedAddressId && (
      <>
        <hr />
        <p className="mt-3">
          <strong>Selected Address:</strong><br />
          {
            (() => {
              const selected =  addresses.find(a => a._id === selectedAddressId);
              return selected
                ? `${selected.addressLine1}, ${selected.addressLine2}, ${selected.city}, ${selected.state} - ${selected.pinCode}, ${selected.country}`
                : '';
            })()
          }
        </p>
        <Button className="w-100 mt-2" variant="success" onClick={handlePayment}>
          Proceed to Pay
        </Button>
      </>
    )}
  </Card>
</Col>

        </Row>
      ) : (
        <p>No items in your cart.</p>
      )}
    </Container>
  );
}

export default Cart;
